"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsUngatedForRemovePieSyncConnectorInstallCount = exports.RatingFilterGate = exports.AppCompatibilityGate = exports.getIsUngatedForAppCompatibility = exports.getPortalScopes = exports.getHasZorseWebticketScope = exports.getHasZorseChatScope = exports.getIsTestUser = exports.getUserId = exports.getUserEmail = exports.getUserDisplayName = exports.PublicOnly = exports.getIsPublic = exports.getIsCustomer = exports.getIsUngated = void 0;

var _reselect = require("reselect");

var _permissionComponents = require("permission-components");

var _env = require("../utils/env");

var getPortal = function getPortal(state) {
  return state.auth.portal;
};

var getUser = function getUser(state) {
  return state.auth.user;
};

var getGates = function getGates(state) {
  return state.auth.gates;
};

var getIsUngated = (0, _reselect.createSelector)([getGates], function (gates) {
  return function (gate) {
    return gates.includes(gate) || (0, _env.debugGate)(gate);
  };
});
exports.getIsUngated = getIsUngated;
var getIsCustomer = (0, _reselect.createSelector)([getPortal], function (portal) {
  return !!(portal && portal.portal_id);
}); // TODO update if public fetches auth info

exports.getIsCustomer = getIsCustomer;
var getIsPublic = (0, _reselect.createSelector)([getIsCustomer], function (isCustomer) {
  return !isCustomer;
});
exports.getIsPublic = getIsPublic;
var PublicOnly = (0, _permissionComponents.makeSimplePermissionComponent)(getIsPublic);
exports.PublicOnly = PublicOnly;
var getUserDisplayName = (0, _reselect.createSelector)([getUser, getIsPublic], function (user, isPublic) {
  return isPublic ? null : user.first_name + " " + user.last_name.slice(0, 1) + ".";
});
exports.getUserDisplayName = getUserDisplayName;
var getUserEmail = (0, _reselect.createSelector)([getUser], function (user) {
  return user.email;
});
exports.getUserEmail = getUserEmail;
var getUserId = (0, _reselect.createSelector)([getUser], function (user) {
  return user.user_id;
});
exports.getUserId = getUserId;
var getIsTestUser = (0, _reselect.createSelector)([getUserEmail], function (userEmail) {
  return userEmail === 'marketplaceteam+acceptancetest@hubspot.com' || userEmail === 'marketplaceteam+speedcurve@hubspot.com';
});
exports.getIsTestUser = getIsTestUser;
var getUserScopes = (0, _reselect.createSelector)([getUser], function (user) {
  return user.scopes;
});
var getHasScope = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return function (scope) {
    return scopes.includes(scope);
  };
});
var getHasZorseChatScope = (0, _reselect.createSelector)([getHasScope], function (hasScope) {
  return hasScope('zorse-chat');
});
exports.getHasZorseChatScope = getHasZorseChatScope;
var getHasZorseWebticketScope = (0, _reselect.createSelector)([getHasScope], function (hasScope) {
  return hasScope('zorse-webticket');
});
exports.getHasZorseWebticketScope = getHasZorseWebticketScope;
var getPortalScopes = (0, _reselect.createSelector)([getPortal], function (portal) {
  return portal.scopes;
});
exports.getPortalScopes = getPortalScopes;
var getIsUngatedForAppCompatibility = (0, _reselect.createSelector)([getIsUngated], function (isUngated) {
  return isUngated('Marketplace:app-compatibility');
});
exports.getIsUngatedForAppCompatibility = getIsUngatedForAppCompatibility;
var AppCompatibilityGate = (0, _permissionComponents.makeSimplePermissionComponent)(getIsUngatedForAppCompatibility);
exports.AppCompatibilityGate = AppCompatibilityGate;
var getIsUngatedForRatingFilter = (0, _reselect.createSelector)([getIsUngated], function (isUngated) {
  return isUngated('Marketplace:filterByRating');
});
var RatingFilterGate = (0, _permissionComponents.makeSimplePermissionComponent)(getIsUngatedForRatingFilter);
exports.RatingFilterGate = RatingFilterGate;
var getIsUngatedForRemovePieSyncConnectorInstallCount = (0, _reselect.createSelector)([getIsUngated], function (isUngated) {
  return isUngated('Marketplace:PieSync:rm-connector-install-count');
});
exports.getIsUngatedForRemovePieSyncConnectorInstallCount = getIsUngatedForRemovePieSyncConnectorInstallCount;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/auth.js
// module id = 41
// module chunks = 209 210 211 212